import { motion } from "framer-motion";
export default function CampusWhatWeOffer() {
    return (
        <div className="w-full h-full flex flex-col   px-8 sm:px-6 md:px-8 lg:px-10 xl:px-12">
            <div className="w-full h-auto flex-col flex items-center justify-center">
                <div className="flex flex-col xs:flex-row items-center gap-2 xs:gap-5 w-auto h-auto">
                    <span className="text-[#F5C400] text-4xl xs:text-5xl sm:text-6xl font-bold">What</span>
                    <span className="text-[#000] text-2xl xs:text-3xl font-bold">We Offer</span>
                </div>
                <motion.svg
                    width="100%"
                    className="h-[30px] xs:h-[40px] sm:h-[45px] md:h-[42px] block -mt-1 xs:-mt-2 max-w-[250px]"
                    viewBox="0 0 600 60"
                    strokeLinecap="round"
                >
                    <motion.path
                        d="M50,40 Q300,-10 550,40"
                        stroke="#F5C400"
                        className="stroke-[6px] xs:stroke-[8px] sm:stroke-[10px]"
                        fill="transparent"
                        initial={{ pathLength: 0, opacity: 0 }}
                        animate={{ pathLength: 1, opacity: 1 }}
                        transition={{ duration: 1.5, ease: "easeInOut" }}
                        whileHover={{
                            d: "M50,40 Q300,15 550,40",
                            transition: { duration: 0.8 }
                        }}
                    />
                </motion.svg>
            </div>

            <div className="flex justify-center items-center  flex-col md:mt-5 xs:gap-14 sm:gap-16 md:gap-20 w-full h-full">
                {/* Left 1*/}
                <div className="flex  flex-col sm:flex-row lg:mr-[4%] items-center justify-center w-full relative h-[180px] xs:h-[200px] sm:h-[150px]">

                    <div className="flex-shrink-0 absolute z-10 left-1/2  xs:bottom-[45%]  sm:left-[5%] md:left-[-2%] md:bottom-[-11%] lg:left-[6%] w-[120px] h-[120px] xs:w-[180px] xs:h-[100px] sm:w-[180px] sm:h-[180px] md:w-[180px] md:h-[180px] lg:w-[200px] lg:h-[200px] bg-blue-600 rounded-full md:text-md md:p-2 flex items-center justify-center text-white text-center font-bold text-sm xs:text-base sm:text-lg  border-[4px] xs:border-[6px] sm:border-[8px] border-white -translate-x-1/2 xs:-translate-x-0" style={{ fontFamily: "Montserrat" }}>
                        Precision-Hired Talent
                    </div>


                    <div className=" lg:w-[80%] xs:min-h-[150px]  md:pt-0 xs:pt-[4%] md:pl-[10%] lg:pl-[10%]  xl:pl-[5%] sm:h-[90%] sm:ml-[10%] md:justify-center    bg-[#D9D9D9] sm:pl-[12%]  sm:pr-[2%]  text-left text-sm xs:text-base sm:text-lg flex justify-center items-center rounded-[10px] mt-[100px] xs:mt-[120px] sm:mt-0" style={{ fontFamily: "Poppins" }}>
                        <div className=" md:w-[85%] xs:w-[90%] lg:w-[80%]">

                            Skip the screening grind. We provide rigorously assessed, role-ready candidates tailored to your needs so you hire faster and smarter.

                        </div>
                    </div>
                </div>

                {/* Right 1*/}




                <div className="flex  flex-col sm:flex-row lg:mr-[4%] items-center justify-center w-full relative h-[180px] xs:h-[200px] sm:h-[150px]">


                    <div className=" lg:w-[80%] xs:min-h-[150px]  md:pt-0 xs:pt-[4%] md:pr-[10%] lg:pr-[10%]  xl:pr-[5%] sm:h-[90%] sm:mr-[6%] md:justify-start    bg-[#D9D9D9] sm:pl-[8%]  sm:pr-[2%]  text-left text-sm xs:text-base sm:text-lg flex justify-center items-center rounded-[10px] mt-[100px] xs:mt-[120px] sm:mt-0" style={{ fontFamily: "Poppins" }}>
                        <div className=" md:w-[85%] xs:w-[90%] lg:w-[95%] xl:w-[85%]" >

                        Your vacancies, everywhere that matters. We turbocharge postings across premium channels to attract top-tier applicants.

                        </div>
                    </div>

                    <div className="flex-shrink-0  absolute z-10 right-1/2 xs:bottom-[42%] md:bottom-[-11%]   md:pl-0   sm:right-[5%] md:right-[-3%]  lg:right-[2%] xl:right-[6%] w-[120px] h-[120px] xs:w-[180px] xs:h-[100px] sm:w-[180px] sm:h-[180px] md:w-[180px] md:h-[180px] bg-[#F5C400] lg:w-[200px] lg:h-[200px] rounded-full flex items-center justify-center text-black text-center font-bold text-sm xs:text-base sm:text-lg md:text-xl border-[4px] xs:border-[6px] sm:border-[8px] border-white translate-x-1/2 xs:translate-x-0 order-1 sm:order-2" style={{ fontFamily: "Montserrat" }}>
                        Amplified Job Visibility
                    </div>
                </div>


                {/* <div className="flex flex-col sm:flex-row items-center align-middle justify-center w-full relative h-[180px] xs:h-[200px] sm:h-[150px]">
 
                    <div className="w-full sm:w-[70%] xs:w-auto xs:h-auto md:w-[90%] xs:px-2 xs:py-5  md:pr[10%] xs:pb-1 xs:pt-5 xs:text-center lg:ml-[15%] lg:pr-[4%] z-0 h-auto  lg:w-[70%]  min-h-[120px] xs:min-h-[150px] sm:h-[90%] sm:mr-[15%] md:mr-[10%] bg-[#D9D9D9] p-4 sm:pr-[12%]  md:pr-[8%] pl-2 sm:pl-[2%] text-center md:text-left text-sm xs:text-base sm:text-lg flex justify-center items-center rounded-[10px] mt-[100px] xs:mt-[120px] sm:mt-0 order-2 sm:order-1" style={{ fontFamily: "Poppins" }}>
                        Your vacancies, everywhere that matters. We turbocharge postings across premium channels to attract top-tier applicants.
                    </div>
 
 
                    <div className="flex-shrink-0  absolute z-10 right-1/2 xs:bottom-[42%] md:bottom-[-11%]   md:pl-0   sm:right-[5%] md:right-[-3%]  lg:right-[2%] xl:right-[6%] w-[120px] h-[120px] xs:w-[180px] xs:h-[100px] sm:w-[180px] sm:h-[180px] md:w-[180px] md:h-[180px] bg-[#F5C400] lg:w-[200px] lg:h-[200px] rounded-full flex items-center justify-center text-black text-center font-bold text-sm xs:text-base sm:text-lg md:text-xl border-[4px] xs:border-[6px] sm:border-[8px] border-white translate-x-1/2 xs:translate-x-0 order-1 sm:order-2" style={{ fontFamily: "Montserrat" }}>
                        Amplified Job Visibility
                    </div>
                </div> */}

                {/* Left 2*/}

                <div className="flex  flex-col sm:flex-row lg:mr-[4%] items-center justify-center w-full relative h-[180px] xs:h-[200px] sm:h-[150px]">

                    <div className="flex-shrink-0 absolute z-10 left-1/2  xs:bottom-[45%]  sm:left-[5%] md:left-[-2%] md:bottom-[-11%] lg:left-[6%] w-[120px] h-[120px] xs:w-[180px] xs:h-[100px] sm:w-[180px] sm:h-[180px] md:w-[180px] md:h-[180px] lg:w-[200px] lg:h-[200px] bg-blue-600 rounded-full md:text-md md:p-2 flex items-center justify-center text-white text-center font-bold text-sm xs:text-base sm:text-lg  border-[4px] xs:border-[6px] sm:border-[8px] border-white -translate-x-1/2 xs:-translate-x-0" style={{ fontFamily: "Montserrat" }}>
                        Employer Brand Studio
                    </div>


                    <div className=" lg:w-[80%] xs:min-h-[150px]  md:pt-0 xs:pt-[4%] md:pl-[10%] lg:pl-[10%]  xl:pl-[5%] sm:h-[90%] sm:ml-[10%] md:justify-center    bg-[#D9D9D9] sm:pl-[12%]  sm:pr-[2%]  text-left text-sm xs:text-base sm:text-lg flex justify-center items-center rounded-[10px] mt-[100px] xs:mt-[120px] sm:mt-0" style={{ fontFamily: "Poppins" }}>
                        <div className=" md:w-[85%] xs:w-[90%] lg:w-[80%]">

                            Stand out with integrated powerful employer branding into every step of the recruitment process  turning hiring into talent attraction.

                        </div>
                    </div>
                </div>


                {/* Right 2*/}

                <div className="flex  flex-col sm:flex-row lg:mr-[4%] items-center justify-center w-full relative h-[180px] xs:h-[200px] sm:h-[150px]">


                    <div className=" lg:w-[80%] xs:min-h-[180px] md:min-h-[150px]  md:pt-0 xs:pt-[4%] md:pr-[10%] lg:pr-[10%]  xl:pr-[5%] sm:h-[90%] sm:mr-[6%] md:justify-start   bg-[#D9D9D9] sm:pl-[8%]  sm:pr-[2%]  text-left text-sm xs:text-base sm:text-lg flex justify-center items-center rounded-[10px] mt-[100px] xs:mt-[120px] sm:mt-0" style={{ fontFamily: "Poppins" }}>
                        <div className=" md:w-[85%] xs:w-[90%] lg:w-[95%] xl:w-[85%] xs:pt-[7%] md:pt-0" >

                            We turn fresh talent into immediate contributors. New hires arrive pre-trained in technical, soft, and operational skills for seamless integration.

                        </div>
                    </div>

                    <div className="flex-shrink-0  absolute z-10 right-1/2 xs:bottom-[42%] md:bottom-[-11%]   md:pl-0   sm:right-[5%] md:right-[-3%]  lg:right-[2%] xl:right-[6%] w-[120px] h-[120px] xs:w-[180px] xs:h-[100px] sm:w-[180px] sm:h-[180px] md:w-[180px] md:h-[180px] bg-[#F5C400] lg:w-[200px] lg:h-[200px] rounded-full flex items-center justify-center text-black text-center font-bold text-sm xs:text-base sm:text-lg md:text-xl border-[4px] xs:border-[6px] sm:border-[8px] border-white translate-x-1/2 xs:translate-x-0 order-1 sm:order-2" style={{ fontFamily: "Montserrat" }}>
                        Zero-to-Pro Workforce
                    </div>
                </div>


                {/* Left 3*/}
                <div className="flex  flex-col sm:flex-row lg:mr-[4%] items-center justify-center w-full relative h-[180px] xs:h-[200px] sm:h-[150px]">

                    <div className="flex-shrink-0 absolute z-10 left-1/2  xs:bottom-[45%]  sm:left-[5%] md:left-[-2%] md:bottom-[-11%] lg:left-[6%] w-[120px] h-[120px] xs:w-[180px] xs:h-[100px] sm:w-[180px] sm:h-[180px] md:w-[180px] md:h-[180px] lg:w-[200px] lg:h-[200px] bg-blue-600 rounded-full md:text-md md:p-2 flex items-center justify-center text-white text-center font-bold text-sm xs:text-base sm:text-lg  border-[4px] xs:border-[6px] sm:border-[8px] border-white -translate-x-1/2 xs:-translate-x-0" style={{ fontFamily: "Montserrat" }}>
                        Done-for-You Recruitment
                    </div>


                    <div className=" lg:w-[80%] xs:min-h-[180px] md:min-h-[150px]  md:pt-0 xs:pt-[4%] md:pl-[10%] lg:pl-[10%]  xl:pl-[5%] sm:h-[90%] sm:ml-[10%] md:justify-center    bg-[#D9D9D9] sm:pl-[12%]  sm:pr-[2%]  text-left text-sm xs:text-base sm:text-lg flex justify-center items-center rounded-[10px] mt-[100px] xs:mt-[120px] sm:mt-0" style={{ fontFamily: "Poppins" }}>
                        <div className=" md:w-[85%] xs:w-[90%] lg:w-[80%] xs:pt-[7%] md:pt-0">

                            From first contact to first day, we orchestrate the entire hiring journey sourcing, shortlisting, coordinating, and onboarding so you can focus on growth.

                        </div>
                    </div>
                </div>



            </div>
        </div>
    )
}